define([
	"dojo/_base/declare",
	"dojo/dom",
	"dojo/dom-class",
	"dojo/query",
	"dojo/topic",
	"lodash",
	"csi/action/Controller",
	"csi/html",
	"csi/page/ViewXml",
	"csi/view",
], function(declare, dom, domClass, query, topic, _, Controller, html, ViewXml, csiView) {

	return declare(Controller, {
		postProcessSuccess() {
			this._toggleViewXML();
			// As we insert/remove extra content to the widget, we need to call resize for the case of popup view
			this._resizeDialog(this.widget);
		},

		_toggleViewXML() {
			// summary: toggle display of View XML
			const {widget} = this;
			const id = widget.defView.getId();

			if (id === "__HeaderToolbar__") {
				// no use in seeing this
				return;
			} else if (id == "DebugConsole") {
				// toggle display for all views
				var nl = query(".debugView");
				if (nl.length) {
					nl.orphan();
					return;
				}

				var domContent = html.pageContent();

				_.each(csiView.getViews(), (v) => {
					if (dom.isDescendant(v.domNode, domContent)) {
						this._viewXml(v);
					}
				});
			} else {
				// toggle display for last clicked view
				var debugNode = html.getParentByClassName(this.m_element, "debugView");
				if (debugNode) {
					if (debugNode.parentNode) {
						debugNode.parentNode.removeChild(debugNode);
					}
					return;
				}

				this._viewXml(widget);
			}
		},

		_viewXml(view) {
			// no reason to show header view
			const {defView, domNode} = view;
			if (!domNode) {
				return;
			}

			const xmlNode = domNode.previousSibling;
			if (xmlNode && domClass.contains(xmlNode, "debugView")) {
				xmlNode.parentNode.removeChild(xmlNode);
				return;
			}

			ViewXml.renderViewXml(defView, domNode, "before");
		},

		_resizeDialog(view) {
			// summary: initiate popup dialog resize 
			if (view && view.bPopup) {
				topic.publish("/csi/dialog/resize/required", true);
			}
		}
	});
});